import { getPublicPagePath } from './utils/getPublicPagePath';
import { start } from './PublicApp';
start(getPublicPagePath()).catch(() => {});